import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ReplaySubject } from 'rxjs';

import { BrowserService } from '../services/browser.service';
import { SideSectionService } from '../services/side-section.service';
import { SideContainerType } from '../social-menu/enums/SideContainerType';

import { ANIMATION_TIMINGS, MOBILE_MOVEMENT_CARD, TutorialCard, TutorialType } from './room-tutorial.types';

@Component({
  selector: 'room-tutorial',
  templateUrl: './room-tutorial.component.html',
  styleUrls: ['./room-tutorial.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('void', style({ opacity: 0 })),
      state('enter', style({ opacity: 1 })),
      transition('* => *', animate(ANIMATION_TIMINGS)),
    ]),
  ],
  standalone: false,
})
export class RoomTutorialComponent implements OnInit, OnDestroy {
  public animationState: 'void' | 'enter' = 'enter';
  public cardIndex = 0;
  protected customHTML: SafeHtml = '';
  public isActionMenuOpen = false;

  @Output() public completeEvent = new EventEmitter<boolean>();
  @Input() public title = '';
  @Input() public showSkip = false;
  @Input() public cards: TutorialCard[] = [];
  @Input() public type: TutorialType = TutorialType.TUTORIAL;

  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(
    private browserService: BrowserService,
    private sanitizer: DomSanitizer,
    private sideSectionService: SideSectionService,
  ) {
    this.isActionMenuOpen = this.sideSectionService.sideContainerType !== SideContainerType.NONE;
  }

  public ngOnInit(): void {
    this.customHTML = this.sanitizer.bypassSecurityTrustHtml(this.cards[1].options?.customHTML || '');

    const isAndroid = this.browserService.isAndroidDevice();
    if (isAndroid && this.type === TutorialType.TUTORIAL) {
      this.cards[1] = { ...MOBILE_MOVEMENT_CARD };
    }
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public isLastCard(): boolean {
    return this.cards.length - 1 === this.cardIndex;
  }

  public onComplete(): void {
    this.completeEvent.next(true);
  }

  public onMobileButtonClicked(): void {
    if (this.isLastCard()) {
      this.onComplete();
      return;
    }
    this.cardIndex++;
  }
}
